<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/task/${inputs.id}`
						: `transaction/task`
				"
			>
				<!-- Assigned Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_assigned_date" class="col-sm-3 mb-0">
						Assigned Date
					</label>
					<app-input
						id="inputs_assigned_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.assigned_date"
						placeholder="Assigned Date"
						:required="true"
						:disabled="true"
					/>
				</div>
				<!-- Due Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_due_date" class="col-sm-3 mb-0">
						Due Date
					</label>
					<app-input
						id="inputs_due_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.due_date"
						placeholder="Due Date"
						:required="true"
					/>
				</div>
				<!-- Due Time -->
				<div class="form-group row align-items-center">
					<label for="inputs_due_time" class="col-sm-3 mb-0">
						Due Time
					</label>
					<app-input
						id="inputs_due_time"
						class="col-sm-9"
						type="time"
						v-model="inputs.due_time"
						placeholder="Due Time"
						:required="true"
					/>
				</div>
				<!-- CLC ID Number -->
				<div
					class="form-group row align-items-center"
					v-if="selectedUrl == '' || selectedUrl == null ? true : false"
				>
					<label for="inputs_clc_id_number" class="col-sm-3 mb-0">
						CLC ID Number
					</label>
					<app-input
						id="inputs_clc_id_number"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_clc_id_number"
						@input="setClcIdNumber"
						:fetch-url="'transaction/lead?clc_id_number_operator=!=&clc_id_number=null'"
						placeholder="CLC ID Number"
						list-value-field="clc_id_number"
					/>
				</div>
				<!-- CLC ID Number -->
				<div
					class="form-group row align-items-center"
					v-if="modalTitle == 'Edit' ? true : false"
				>
					<label
						for="inputs_clc_id_number_edit"
						class="col-sm-3 mb-0"
					>
						CLC ID Number Code
					</label>
					<app-input
						id="inputs_clc_id_number_edit"
						class="col-sm-9"
						type="text"
						v-model="inputs.clc_id_number"
						placeholder="CLC ID Number"
						:readOnly="true"
					/>
				</div>

				<div
					class="form-group row align-items-center"
					v-if="modalTitle == 'Edit' ? true : false"
				>
					<label
						for="inputs_clc_id_number_edit"
						class="col-sm-3 mb-0"
					>
						Full Name
					</label>
					<app-input
						id="inputs_full_name_edit"
						class="col-sm-9"
						type="text"
						v-model="inputs.full_name"
						placeholder="Full Name"
						:readOnly="true"
					/>
				</div>

				<!-- Task -->
				<div class="form-group row align-items-center">
					<label for="inputs_task" class="col-sm-3 mb-0">
						Task
					</label>
					<app-input
						id="inputs_task"
						class="col-sm-9"
						type="text"
						v-model="inputs.title"
						placeholder="Task"
						:required="true"
					/>
				</div>
				<!-- Assigned To -->
				<div class="form-group row align-items-center">
					<label for="inputs_assignee_id" class="col-sm-3 mb-0">
						Assigned To
					</label>
					<app-input
						id="inputs_assignee_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.assignee_id"
						:list="assignedToLists"
						placeholder="Assigned To"
						:required="true"
					/>
				</div>
				<!-- Assigned By -->
				<div class="form-group row align-items-center">
					<label for="inputs_owner_id" class="col-sm-3 mb-0">
						Assigned By
					</label>
					<app-input
						id="inputs_owner_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.owner_id"
						:list="assignedByLists"
						placeholder="Assigned By"
						:disabled="selectedUrl == '' || selectedUrl == null ? true : false"
					/>
				</div>

				<!-- Assigned By -->
				<div class="form-group row align-items-center">
					<label for="inputs_owner_id" class="col-sm-3 mb-0">
						Status
					</label>
					<app-input
						id="inputs_stage_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.stage_id"
						:list="stageList"
						placeholder="Status"
						:disabled="selectedUrl == '' || selectedUrl == null ? true : false"
					/>
				</div>

				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { UserMixin } from "../../Auth/Mixins/UserMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin, UserMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					course_type_name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			assignedToLists: [],
			assignedByLists: [],
			stageList: [],
			input_clc_id_number: this.value
				? this.value.lead
					? {
							id: this.value.lead.id || 0,
							full_name: this.value.lead.full_name || "",
					  }
					: {
							id: this.value.lead?.id || 0,
							full_name: this.value.lead?.full_name || "",
					  }
				: {
						id: this.value.lead.id || 0,
						full_name: this.value.lead.full_name || "",
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		} else {
			this.inputs.assigned_date = this.formattedDate(new Date());
			this.inputs.owner_id = this.user.loggedInUser.id;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [userResponse, stageResponse] = await Promise.all([
					axios.get("/user-list?per_page=1000"),
					axios.get("/master/stage?per_page=1000"),
				]);

				userResponse.data.data.forEach((item) => {
					this.assignedByLists.push({
						id: item.id,
						value: item.full_name,
					});

					this.assignedToLists.push({
						id: item.id,
						value: item.full_name,
					});
				});

				stageResponse.data.data.forEach((item) => {
					this.stageList.push({
						id: item.id,
						value: item.name,
					});

					if (this.selectedUrl == "" || this.selectedUrl == null) {
						if (item.name.toLowerCase() == "pending") {
							this.inputs.stage_id = item.id;
						}
					}
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.inputs.assigned_date = this.formattedDate(
				this.inputs.assigned_date
			);
			this.inputs.due_date = this.formattedDate(this.inputs.due_date);
			if (this.inputs.stage_id == 3) {
				this.inputs.accomplished_by_id = this.user.loggedInUser.id;
				this.inputs.accomplished_by_name = this.user.loggedInUser.full_name;
				this.inputs.accomplished_date = this.formattedDate(new Date());
				this.inputs.accomplished_time = this.getCurrentTimeFormatted(new Date());
			} else {
				this.inputs.accomplished_by_id = null;
				this.inputs.accomplished_by_name = null;
				this.inputs.accomplished_date = null;
				this.inputs.accomplished_time = null;
			}
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.inputs.full_name = response.data.lead?.full_name;
			this.inputs.due_time = response.data.due_time.slice(0, -3) || "";
			this.inputs.assignee_id = response.data.assignee_id?.id || 0;
			this.inputs.owner_id = response.data.owner_id?.id || 0;
			this.inputs.stage_id = response.data.stage_id?.id || 0;
			this.preloader = false;
		},
		formattedDate(dateParam) {
			const originalDate = dateParam;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
		getCurrentTimeFormatted(dateParam) {
			// convert to "20:53:16" format
			const originalDate = dateParam;
			const date = new Date(originalDate);

			const hours = date.getHours().toString().padStart(2, "0");
			const minutes = date.getMinutes().toString().padStart(2, "0");
			const seconds = date.getSeconds().toString().padStart(2, "0");

			const formattedTime = `${hours}:${minutes}:${seconds}`;

			return formattedTime;
		},

		setClcIdNumber(data) {
			this.inputs.clc_id_number = this.inputs.clc_id_number;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.clc_id_number = data.clc_id_number;
			}
		},
	},
};
</script>
